export default __webpack_public_path__ + "static/media/class_join.8207979e.svg";